/**
 * @file Input component for label input
 * @author Heino Lenting
 */
import * as tslib_1 from "tslib";
import { InputBase } from '../input-base/input-base';
/**
 * Class for the label input component
 */
var InputLabelComponent = /** @class */ (function (_super) {
    tslib_1.__extends(InputLabelComponent, _super);
    function InputLabelComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.translate = false;
        return _this;
    }
    Object.defineProperty(InputLabelComponent.prototype, "isAllCaps", {
        /**
         * Gets a value indicating whether the value is all in capitals.
         *
         * @readonly
         * @type {boolean}
         */
        get: function () {
            if (!this.value) {
                return false;
            }
            return this.value.toUpperCase() === this.value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputLabelComponent.prototype, "diplayMode", {
        get: function () {
            if (this.translate) {
                return 'TRANSLATE';
            }
            if (this.isAllCaps) {
                return 'ALL-CAPITALS';
            }
            return 'DEFAULT';
        },
        enumerable: true,
        configurable: true
    });
    return InputLabelComponent;
}(InputBase));
export { InputLabelComponent };
